// Shared watchers for the vector-upload / private-memory form state in the two
// streaming chat views (Stream.vue, FullStreamReDesign.vue). The four watchers below
// were byte-identical (whitespace-insensitive) in both components and were extracted
// for SonarQube dedup; behavior unchanged. The diverged watchers (User_Id,
// Flag_Click_History, options_ListFilePM, options, ...) stay in each component.
export default {
  watch: {
    KeyTopic: function () {
      this.$nextTick(() => {
        this.ClearValuePrivate_Memory();
      });
    },
    requestVector: {
      handler(newVal) {
        if (newVal.modelType != 3) {
          this.requestVector.customCharacter = null;
        }
      },
      deep: true,
    },
    doctype: {
      handler(val) {
        this.vectortype = null;
        this.requestVector.customCharacter = null;
        this.filterDDType = [];
        this.filterdatavectortype = [];
        if (val == 1 || val == 2) {
          this.filterdatavectortype = this.datavectortype.filter(
            (e) => e.value != 2
          );
        } else {
          this.filterdatavectortype = this.datavectortype.filter(
            (e) => e.value != 3
          );
        }
        this.setTypeFile(val);
      },
    },
    vectortype: {
      handler(val) {
        this.filterDDType = [];
        this.requestVector.customCharacter = null;
        if (val == 2) {
          this.filterDDType = this.DDType.filter((e) => e.value == 4);
        } else if (val == 3 && (this.doctype == 1 || this.doctype == 2)) {
          this.filterDDType = this.DDType.filter(
            (e) => e.value == 5 || e.value == 6
          );
        } else if (this.doctype == 4) {
          this.filterDDType = this.DDType.filter(
            (e) =>
              e.value == 1 || e.value == 2 || e.value == 3 || e.value == 7
          );
        } else if (this.doctype == 3) {
          this.filterDDType = this.DDType.filter(
            (e) =>
              e.value == 1 || e.value == 2 || e.value == 3 || e.value == 8
          );
        } else {
          this.filterDDType = this.DDType.filter(
            (e) => e.value == 1 || e.value == 2 || e.value == 3
          );
        }
        this.requestVector.modelType = null;
      },
    },
  },
};
